<template>
    <div :class="classList">
        <div class="part-cell-image">
            <Thumbnail />
        </div>
        <div class="part-cell-data">
            <span class="part-cell-title">Part #{{ identifier }}</span>
        </div>
    </div>
</template>
<script>

import Thumbnail from '@/Components/Thumbnail'

export default {
    components: {
        Thumbnail,
    },
    props: {
        extra: {
            type: Object,
            default: {}
        },
        value: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        return {
            ...this.value,
        }
    },
    computed: {
        classList() {
            const list = ['part-cell']

            return  list.join(' ')
        }
    }
}
</script>
<style scoped>

    .part-cell {
        display: flex;
        align-items: center;
    }

    .part-cell.priority {
        color: var(--default-primary);
    }

    .part-cell-image {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        margin-right: 20px;
        border-radius: var(--default-border-radius);
    }

    .part-cell svg {
        height: 55%;
        color: var(--default-white);
    }

    .part-cell span {
    }

    .part-cell-data {
        display: flex;
        flex-direction: column;
    }

    .part-cell-title {
        font-weight: 900;
    }

    .part-cell-meta {
        display: flex;
        align-items: center;
        margin-bottom: .5em;
        font-size: 9px;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0.125em;
    }

    .part-cell-meta svg {
        width: 1.5em;
        color: inherit;
        margin-right: .5em;
    }

</style>
